// extracted by mini-css-extract-plugin
module.exports = {"container":"BettingWidget_container__n0N17","header":"BettingWidget_header__bkKsT","title":"BettingWidget_title__ZiyaR"};